import React from 'react';

import { IIconProps, TIconType } from '../interface';

const StopIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<g clipPath='url(#clip0_28171_22351)'>
				<path
					d='M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M14.25 9.75H9.75V14.25H14.25V9.75Z'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</g>
			<defs>
				<clipPath id='clip0_28171_22351'>
					<rect
						fill='white'
						height='24'
						width='24'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default StopIcon;
